import route from './route';
import { LazyloadWrapper } from '../../Components/Common';

const Perks = LazyloadWrapper(import('./Perks'));

export default {
  RenderProp: Perks,
  mainRoute: route,
};
